import { errorLogger } from "@/Common/helpers/logger";
import { apiInstance, gql } from "@/services/httpAdapter";
// Types
import { IPaginatedResponse } from "@/Common/api/types/pagination";
import { GraphqlQueryResponse } from "@/Common/api/types/GraphqlQueryResponse";
import { INotification, INotificationExtraInfo } from "@/Common/api/types/notifications";

export async function countNewNotifications(locationId: string) {
	const query = gql`
		query countNewNotifications($locationId: String!) {
			countNewNotifications(locationId: $locationId)
		}
	`;

	const variables = {
		locationId,
	};

	try {
		const response: GraphqlQueryResponse<"data", number> = await apiInstance.post("/graphql", { query, variables });
		return response.data;
	} catch (err) {
		errorLogger(err as Error, { function: "getNotifications", message: "Error retrieving new notifications count", variables });
		throw err;
	}
}

export async function getPaginatedNotifications({
	locationId,
	onlyUnRead,
	after,
	first,
	archived,
}: {
	locationId: string;
	onlyUnRead: boolean;
	after: string;
	first: number;
	archived?: boolean;
}) {
	const query = gql`
		query getNotifications($locationId: String!, $filter: NotificationsFilterInput, $pagination: PaginationInput) {
			getNotifications(locationId: $locationId, filter: $filter, pagination: $pagination) {
				__typename
				... on PaginatedNotifications {
					edges {
						node {
							_id
							createdAt
							createdBy
							message
							newNotification
							read
							userId
							topic
							archived
						}
					}
					pageInfo {
						hasNextPage
						endCursor
						totalCount
						currentFilterCount
						unreadCount
						newCount
						unreadArchivedCount
					}
				}
			}
		}
	`;

	const variables = {
		locationId,
		filter: {
			onlyUnRead,
			archived,
		},
		pagination: { after, first },
	};

	try {
		const result: GraphqlQueryResponse<"getNotifications", IPaginatedResponse<INotification, INotificationExtraInfo>[]> =
			await apiInstance.post("/graphql", {
				query,
				variables,
			});

		if (!result.data.data?.getNotifications[0]) {
			throw new Error("Error retrieving paginated notification list");
		}

		return result.data.data?.getNotifications[0];
	} catch (err) {
		errorLogger(err as Error, { function: "getNotifications", message: "Error retrieving paginated notification list", variables });
		throw err;
	}
}
